import * as React from 'react';
import { WrappedFieldProps } from 'redux-form';

interface IOptions {
  name: string;
  value: string;
}

interface IFormSelectProps {
  placeholder?: string;
  options: IOptions[];
  isDisabled?: boolean;
  showDefault?: boolean;
}

export default function FormSelect(
  props: WrappedFieldProps & IFormSelectProps,
) {
  const {
    input,
    placeholder = 'Seleccione',
    options,
    isDisabled = false,
    meta: { touched, error },
    showDefault = true,
  } = props;

  return (
    <div>
      <div className={"select-container" + (error && touched ? " invalid-form-input" : "")}>
        <select
          {...input}
          id={input.name}
          placeholder={placeholder}
          className={"form-control" + (error && touched ? " invalid-form-input" : "")}
          disabled={isDisabled}
        >
          {showDefault && <option value="" disabled>{placeholder}</option>}
          {options.map(option => (
            <option key={option.name} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
      </div>
      {touched && error && <small className="invalid">{error}</small>}
    </div>
  );
}
